import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const DeviceBatchSelectFieldFilter = ({ deviceBatchId, deviceBatches, onChange }) => (
  <ResourceSelectFieldFilter
    labelId="field.productionBatch"
    resourceId={deviceBatchId}
    resources={deviceBatches.elements.data}
    displayKey="name"
    onChange={onChange}
  />
);

DeviceBatchSelectFieldFilter.propTypes = {
  deviceBatchId: PropTypes.number,
  deviceBatches: fullListShape.isRequired,
  onChange: PropTypes.func.isRequired,
};

DeviceBatchSelectFieldFilter.defaultProps = {
  deviceBatchId: null,
};

const mapStateToProps = (state) => ({
  deviceBatches: state.deviceBatch.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(DeviceBatchSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/production/assets/deviceBatch/DeviceBatchSelectFieldFilter.js